export default __webpack_public_path__ + "a7427e1ccf18f80eb24c1e70a9994d31.svg";